import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import _ from 'lodash';
import React, { Component } from 'react';
import FlatList from "react-native-web/dist/exports/FlatList";
import View from "react-native-web/dist/exports/View";
import Text from "react-native-web/dist/exports/Text";
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import XDate from 'xdate';
import styleConstructor from "./style";
import CalendarList from "../calendar-list";
import Week from "../expandableCalendar/week";
import asCalendarConsumer from "./asCalendarConsumer";
import { weekDayNames } from "../dateutils";
import { jsx as ___EmotionJSX } from "@emotion/core";

var commons = require("./commons");

var UPDATE_SOURCES = commons.UPDATE_SOURCES;
var NUMBER_OF_PAGES = 2;

var WeekCalendar = function (_Component) {
  _inherits(WeekCalendar, _Component);

  var _super = _createSuper(WeekCalendar);

  function WeekCalendar(props) {
    var _this;

    _classCallCheck(this, WeekCalendar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onDayPress", function (value) {
      _.invoke(_this.props.context, 'setDate', value.dateString, UPDATE_SOURCES.DAY_PRESS);
    });

    _defineProperty(_assertThisInitialized(_this), "onScroll", function (_ref) {
      var x = _ref.nativeEvent.contentOffset.x;
      var newPage = Math.round(x / _this.containerWidth);

      if (_this.page !== newPage) {
        var items = _this.state.items;
        _this.page = newPage;

        _.invoke(_this.props.context, 'setDate', items[_this.page], UPDATE_SOURCES.WEEK_SCROLL);

        if (_this.page === items.length - 1) {
          for (var i = 0; i <= NUMBER_OF_PAGES; i++) {
            items[i] = items[i + NUMBER_OF_PAGES];
          }

          _this.setState({
            items: _toConsumableArray(items)
          });
        } else if (_this.page === 0) {
          for (var _i = items.length - 1; _i >= NUMBER_OF_PAGES; _i--) {
            items[_i] = items[_i - NUMBER_OF_PAGES];
          }

          _this.setState({
            items: _toConsumableArray(items)
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMomentumScrollEnd", function () {
      var items = _this.state.items;
      var isFirstPage = _this.page === 0;
      var isLastPage = _this.page === items.length - 1;

      if (isFirstPage || isLastPage) {
        _this.list.current.scrollToIndex({
          animated: false,
          index: NUMBER_OF_PAGES
        });

        _this.page = NUMBER_OF_PAGES;

        var newWeekArray = _this.getDatesArray();

        if (isLastPage) {
          for (var i = NUMBER_OF_PAGES + 1; i < items.length; i++) {
            items[i] = newWeekArray[i];
          }
        } else {
          for (var _i2 = 0; _i2 < NUMBER_OF_PAGES; _i2++) {
            items[_i2] = newWeekArray[_i2];
          }
        }

        setTimeout(function () {
          _this.setState({
            items: _toConsumableArray(items)
          });
        }, 100);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderItem", function (_ref2) {
      var item = _ref2.item;

      var _this$props = _this.props,
          calendarWidth = _this$props.calendarWidth,
          style = _this$props.style,
          onDayPress = _this$props.onDayPress,
          others = _objectWithoutProperties(_this$props, ["calendarWidth", "style", "onDayPress"]);

      return ___EmotionJSX(Week, _extends({}, others, {
        key: item,
        current: item,
        style: [{
          width: calendarWidth || _this.containerWidth
        }, style],
        markedDates: _this.getMarkedDates(),
        onDayPress: onDayPress || _this.onDayPress
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "getItemLayout", function (data, index) {
      return {
        length: _this.containerWidth,
        offset: _this.containerWidth * index,
        index: index
      };
    });

    _defineProperty(_assertThisInitialized(_this), "keyExtractor", function (item, index) {
      return index.toString();
    });

    _this.style = styleConstructor(props.theme);
    _this.list = React.createRef();
    _this.page = NUMBER_OF_PAGES;
    _this.state = {
      items: _this.getDatesArray()
    };
    return _this;
  }

  _createClass(WeekCalendar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props$context = this.props.context,
          updateSource = _this$props$context.updateSource,
          date = _this$props$context.date;

      if (date !== prevProps.context.date && updateSource !== UPDATE_SOURCES.WEEK_SCROLL) {
        this.setState({
          items: this.getDatesArray()
        });
        this.list.current.scrollToIndex({
          animated: false,
          index: NUMBER_OF_PAGES
        });
      }
    }
  }, {
    key: "getDatesArray",
    value: function getDatesArray() {
      var array = [];

      for (var index = -NUMBER_OF_PAGES; index <= NUMBER_OF_PAGES; index++) {
        var d = this.getDate(index);
        array.push(d);
      }

      return array;
    }
  }, {
    key: "getDate",
    value: function getDate(weekIndex) {
      var _this$props2 = this.props,
          current = _this$props2.current,
          context = _this$props2.context,
          firstDay = _this$props2.firstDay;
      var d = XDate(current || context.date);
      var dayOfTheWeek = d.getDay();

      if (dayOfTheWeek < firstDay && firstDay > 0) {
        dayOfTheWeek = 7 + dayOfTheWeek;
      }

      var dd = weekIndex === 0 ? d : d.addDays(firstDay - dayOfTheWeek);
      var newDate = dd.addWeeks(weekIndex);
      return newDate.toString('yyyy-MM-dd');
    }
  }, {
    key: "getMarkedDates",
    value: function getMarkedDates() {
      var _this$props3 = this.props,
          context = _this$props3.context,
          markedDates = _this$props3.markedDates;

      if (markedDates) {
        var marked = _.cloneDeep(markedDates);

        if (marked[context.date]) {
          marked[context.date].selected = true;
        } else {
          marked[context.date] = {
            selected: true
          };
        }

        return marked;
      }

      return _defineProperty({}, context.date, {
        selected: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          allowShadow = _this$props4.allowShadow,
          firstDay = _this$props4.firstDay,
          hideDayNames = _this$props4.hideDayNames,
          current = _this$props4.current,
          context = _this$props4.context;
      var items = this.state.items;
      var weekDaysNames = weekDayNames(firstDay);
      var extraData = Map({
        current: current,
        date: context.date,
        firstDay: firstDay
      });
      return ___EmotionJSX(View, {
        testID: this.props.testID,
        style: [allowShadow && this.style.containerShadow, !hideDayNames && {
          paddingBottom: 6
        }]
      }, !hideDayNames && ___EmotionJSX(View, {
        style: [this.style.week, {
          marginTop: 12,
          marginBottom: -2
        }]
      }, weekDaysNames.map(function (day, idx) {
        return ___EmotionJSX(Text, {
          allowFontScaling: false,
          key: idx,
          style: _this2.style.dayHeader,
          numberOfLines: 1,
          accessibilityLabel: ''
        }, day);
      })), ___EmotionJSX(FlatList, {
        ref: this.list,
        data: items,
        extraData: extraData,
        style: this.style.container,
        horizontal: true,
        showsHorizontalScrollIndicator: false,
        pagingEnabled: true,
        scrollEnabled: true,
        renderItem: this.renderItem,
        keyExtractor: this.keyExtractor,
        initialScrollIndex: NUMBER_OF_PAGES,
        getItemLayout: this.getItemLayout,
        onScroll: this.onScroll,
        onMomentumScrollEnd: this.onMomentumScrollEnd
      }));
    }
  }, {
    key: "containerWidth",
    get: function get() {
      return this.props.calendarWidth || commons.screenWidth;
    }
  }]);

  return WeekCalendar;
}(Component);

_defineProperty(WeekCalendar, "displayName", 'WeekCalendar');

_defineProperty(WeekCalendar, "propTypes", _objectSpread({}, CalendarList.propTypes, {
  current: PropTypes.any,
  allowShadow: PropTypes.bool,
  hideDayNames: PropTypes.bool
}));

_defineProperty(WeekCalendar, "defaultProps", {
  firstDay: 0,
  allowShadow: true
});

var __DOCZ_DUMMY_EXPORT_DEFAULT = asCalendarConsumer(WeekCalendar);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/react-native-calendars/src/expandableCalendar/weekCalendar.js"
    }
  });
}